import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'companion-app-components/flux/core/actionHelpers';
import { QcsSyncResourcesPayload } from 'companion-app-components/flux/core/resourceStoreTypes';
import { CategoryGroupListProps } from 'companion-app-components/flux/category-group-lists/categoryGroupListsTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const categoryGroupsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CategoryGroupListProps>>();

export const createCategoryGroupListsAction = createAction('CREATE_CATEGORY_GROUP_LISTS', categoryGroupsPayloadCreator);
export const createCategoryGroupListsSuccessAction = createAction(
  'CREATE_CATEGORY_GROUP_LISTS_SUCCESS',
  categoryGroupsPayloadCreator,
);
export const createCategoryGroupListsFailureAction = createAction('CREATE_CATEGORY_GROUP_LISTS_FAILURE', errorPayloadCreator);
